// Global
import { useTranslation } from 'react-i18next';
import { TrashIcon } from '@storybook/icons';

// Components
import { EyeIcon, PdfIcon } from '@/icons';
import {
  StyledWrapper,
  StyledActionButton,
  StyledContentBlock,
  StyledDescription,
  StyledDeleteButton,
} from './DocumentItemStyles';
import DeleteConfirmationModal from '../DeleteConfirmationModal/DeleteConfirmationModal';

// Models
import { IPropertyFile } from '@/models/documents.model';
import { IFile } from '@/models/file.model';

// Helpers
import { formatDate } from '@/utils';
import { useModal } from '@/hooks';
import { DateFormats } from '@/constants/dates';
import { normalizeDocument } from '../../helpers/normalizers';

type TDocumentItem = {
  document: Partial<IPropertyFile> | Partial<IFile>;
  onDocumentDelete?: (id: string) => void;
  disabled?: boolean;
};

const DocumentItem = ({ document, onDocumentDelete, disabled }: TDocumentItem) => {
  const { closeModal, isOpened, openModal } = useModal();
  const { t } = useTranslation('common');

  const normalizedDocument = normalizeDocument(document);

  const onDelete = () => onDocumentDelete?.(normalizedDocument.id as string);
  const onPreview = () => window.open(normalizedDocument.file_link);

  return (
    <StyledWrapper>
      <PdfIcon />
      <StyledContentBlock>
        <span>{normalizedDocument.file_name}</span>
        {normalizedDocument.uploadedBy && (
          <StyledDescription>
            {t(`uploaded_by_${normalizedDocument.uploadedBy}`)}{' '}
            {formatDate(normalizedDocument.created ?? '', DateFormats.DEFAULT)}
          </StyledDescription>
        )}
      </StyledContentBlock>
      <StyledActionButton onClick={onPreview}>
        <EyeIcon />
      </StyledActionButton>
      {onDocumentDelete && !disabled && (
        <StyledDeleteButton onClick={openModal}>
          <TrashIcon />
        </StyledDeleteButton>
      )}
      <DeleteConfirmationModal isOpened={isOpened} onClose={closeModal} onConfirm={onDelete} />
    </StyledWrapper>
  );
};

export default DocumentItem;
